"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _useA11y2 = _interopRequireDefault(require("../../hooks/useA11y"));

var _CommentListSectionHeader = _interopRequireDefault(require("./CommentListSectionHeader.scss"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var CommentListSectionHeader = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  var buttonRef = (0, _react.useRef)();

  var _useA11y = (0, _useA11y2.default)(buttonRef.current),
      onKeyDown = _useA11y.onKeyDown;

  var id = props.id,
      title = props.title,
      _props$subtitle = props.subtitle,
      subtitle = _props$subtitle === void 0 ? '' : _props$subtitle,
      sticky = props.sticky,
      _props$onClick = props.onClick,
      onClick = _props$onClick === void 0 ? function () {} : _props$onClick;
  var className = (0, _classnames.default)(_CommentListSectionHeader.default.component, _defineProperty({}, _CommentListSectionHeader.default.sticky, sticky));
  return /*#__PURE__*/_react.default.createElement("h3", {
    ref: ref,
    id: id,
    className: className
  }, /*#__PURE__*/_react.default.createElement("button", {
    ref: buttonRef,
    "aria-expanded": "true",
    className: _CommentListSectionHeader.default.headingButton,
    onClick: onClick,
    onKeyDown: onKeyDown
  }, /*#__PURE__*/_react.default.createElement("span", null, title), subtitle && /*#__PURE__*/_react.default.createElement("span", {
    className: _CommentListSectionHeader.default.subtitle
  }, subtitle && ": ".concat(subtitle))));
});
CommentListSectionHeader.propTypes = {
  id: _propTypes.default.string,
  onClick: _propTypes.default.func,
  sticky: _propTypes.default.bool,
  subtitle: _propTypes.default.string,
  title: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.element]).isRequired
};
var _default = CommentListSectionHeader;
exports.default = _default;